export default {"src":"/_next/static/media/Group 7013.e1350b5a.svg","height":53,"width":186,"blurWidth":0,"blurHeight":0};